<template>
  <div
    :class="['zg-quote', {
      [`zq-quote--background-${background}`]: background,
      [`zq-quote--direction-${direction}`]: direction
    }]"
  >
    <div class="quote">
      <slot v-if="$slots.default" />

      <p
        v-else-if="text"
        v-html="text"
      />
    </div>

    <svg
      width="50"
      height="40"
      viewBox="0 0 50 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.345214 5.80016C0.372848 5.8644 0.396141 5.932 0.411376 6.00026L8 40L50 40L6.52138 0.635151C6.46304 0.582325 6.39768 0.535511 6.3277 0.499489C2.7733 -1.33018 -1.20681 2.19166 0.345214 5.80016Z" />
    </svg>
  </div>
</template>

<script>
  export default {
    name: 'ZgQuote',
    props: {
      text: {
        type: String,
        required: false,
        default: null
      },
      background: {
        type: String,
        required: false,
        default: 'beige',
        validator: (value) => [
          'beige',
          'secondary-500'
        ].includes(value)
      },
      direction: {
        type: String,
        required: false,
        default: 'bottom-left',
        validator: (value) => [
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right',
          'left-top',
          'left-bottom',
          'right-top',
          'right-bottom'
        ].includes(value)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .zg-quote {
    position: relative;
    padding: rem(24px);
    border-radius: radius(large);

    @include mq(medium) {
      padding: rem(32px);
    }

    .quote {
      p,
      ::v-deep p {
        @include type-title-m;

        &:last-child {
          margin: 0;
        }
      }
    }

    svg {
      position: absolute;
      width: auto;
      height: rem(40px);
    }
  }

  // ? ----------------------------------------------------------------------
  // background
  // ? ----------------------------------------------------------------------

  .zq-quote--background-beige {
    background-color: color(beige);

    svg {
      fill: color(beige);
    }
  }

  .zq-quote--background-secondary-500 {
    background-color: color(secondary-500);

    svg {
      fill: color(secondary-500);
    }
  }

  // ? ----------------------------------------------------------------------
  // directions
  // ? ----------------------------------------------------------------------

  .zq-quote--direction-top-left {
    margin-top: rem(32px);

    svg {
      top: rem(8px);
      left: rem(46px);
      transform: translateY(-100%);
    }
  }

  .zq-quote--direction-top-right {
    margin-top: rem(32px);

    svg {
      top: rem(8px);
      right: rem(46px);
      transform: translateY(-100%) scaleX(-1);
    }
  }

  .zq-quote--direction-bottom-left {
    margin-bottom: rem(32px);

    svg {
      top: calc(100% - #{rem(8px)});
      left: rem(46px);
      transform: rotateX(180deg);
    }
  }

  .zq-quote--direction-bottom-right {
    margin-bottom: rem(32px);

    svg {
      top: calc(100% - #{rem(8px)});
      right: rem(46px);
      transform: rotateX(180deg) scaleX(-1);
    }
  }

  .zq-quote--direction-left-top {
    margin-left: rem(32px);

    svg {
      top: rem(32px);
      left: - rem(32px);
      transform: rotate(90deg) scale(1, -1);
    }
  }

  .zq-quote--direction-left-bottom {
    margin-left: rem(32px);

    svg {
      bottom: rem(32px);
      left: - rem(32px);
      transform: rotate(90deg) scale(-1, -1);
    }
  }

  .zq-quote--direction-right-top {
    margin-right: rem(32px);

    svg {
      top: rem(32px);
      right: - rem(32px);
      transform: rotate(90deg);
    }
  }

  .zq-quote--direction-right-bottom {
    margin-right: rem(32px);

    svg {
      bottom: rem(32px);
      right: - rem(32px);
      transform: rotate(90deg) scale(-1, 1);
    }
  }
</style>
